import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { SvgService } from '../../services/icon/icon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'sit-svg',
  styleUrls: ['./svg.component.css'],
  template: `<span class="svg-container" [innerHtml]="svgHtml"></span>`
})
export class SvgComponent implements OnInit {
  @Input() path: string;

  svgHtml: SafeHtml;

  constructor(private svgService: SvgService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loadSvg();
  }

  async loadSvg() {
    try {
      const svgContent = await this.svgService.getSvg(this.path);
      this.svgHtml = this.sanitizer.bypassSecurityTrustHtml(svgContent);
      // this.svgHtml = this.sanitizer.sanitize(SecurityContext.HTML, svgContent);
    } catch (error) {
      console.error('Error loading SVG:', error);
    }
  }
}
